export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8842.20f7848b.jpg";